import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersComponent } from '@app/features/customers/customers/customers.component';
import { AddCustomerComponent } from '@app/features/customers/add-customer/add-customer.component';
import { ViewCustomerComponent } from '@app/features/customers/view-customer/view-customer.component';
import { EditCustomerComponent } from '@app/features/customers/edit-customer/edit-customer.component';

const routes: Routes = [
  { path: '', component: CustomersComponent },
  { path: 'add', component: AddCustomerComponent },
  { path: ':customerId/edit', component: EditCustomerComponent },
  { path: ':customerId', component: ViewCustomerComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomersRoutingModule { }
